import React from "react";
import { cn } from "../../lib/utils/cn";

interface UnreadIndicatorProps {
	count?: number;
	showCount?: boolean;
	className?: string;
}

export const UnreadIndicator: React.FC<UnreadIndicatorProps> = ({
	count = 0,
	showCount = false,
	className,
}) => {
	if (!count || count === 0) {
		return null;
	}

	// Show count badge if showCount is true and count > 0
	if (showCount && count > 0) {
		return (
			<div
				className={cn(
					"flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-blue-600 text-white text-xs font-medium",
					className
				)}
			>
				{count > 99 ? "99+" : count}
			</div>
		);
	}

	// Otherwise show simple dot
	return (
		<div
			className={cn(
				"w-2 h-2 rounded-full bg-blue-600",
				className
			)}
		/>
	);
};